//REACT-JS
import React from 'react';
import { withRouter } from 'react-router-dom';

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

//COMPONENTS
import { relatorioAction } from '../../store/relatorio';

class TableDetalheAgendamentoToi extends React.Component {

    constructor(props) {
        super(props);
    }

    static defaultProps = {
        name: "",
        selected: 0,
        onChange: function(e){}
    };

    render() {

        const data = this.props.data; let html = "";

        if (data.results === undefined) {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0 || data.results === 0) {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length > 0) {
            html = data.results.map(row =>
                <tr key={row.identificador} id={row.codigo}>
                    <td>{row.identificador}</td>
                    <td>{row.email}</td>
                    <td>{row.telefone}</td>
                    <td>{row.dataHoraEnvio}</td>
                    <td>{row.dataHoraEnvioSms}</td>
                    <td>{row.data1}</td>
                    <td>{row.data2}</td>
                    <td style={{display: "none"}}>{row.mailing}</td>
                </tr>                  
            );
        }

        return(
            <div style={{maxHeight: "400px", overflowY: "auto"}}>
                <table className="footable table table-striped toggle-arrow-tiny text-body" id="table-to-export">
                    <thead>
                        <tr style={{backgroundColor: "#dbf1e9"}}>       
                            <th>Identificador</th>
                            <th>E-mail</th>
                            <th>Telefone</th>
                            <th>Data/Hora do envio e-mail</th>
                            <th>Data/Hora do envio sms</th>
                            <th>Data escolhida</th>
                            <th>Turno escolhido</th>
                            <th style={{display: "none"}}>Mailing</th>
                        </tr>
                    </thead>

                    <tbody>{html}</tbody>
                </table>            
            </div>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, relatorio: state.relatorio };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { relatorio: bindActionCreators(relatorioAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableDetalheAgendamentoToi));